module.exports = __webpack_public_path__ + "static/loading-text-f4b0704342bb399ef821c7c1fbea685c.mp4";